import React from 'react'
import { Box, Button, Stack } from '@mui/material'
import {
    ExpandMore as ChevronDown,
    ExpandLess as ChevronUp
} from '@mui/icons-material'
import { ResizablePanel } from '../../components/Resizable/resizable'
import { DynamicTabsComponent } from '../../components/dynamictabs/DynamicTabsComponent'
import DocumentFooterSkeleton from '../../components/skeletons/DocumentFooterSkeleton'

const Footer = ({ footerOpen, toggleFooter, FooterCategories, isLoading }) => {
    return (
        <>
            <Box sx={{ position: 'relative', height: 8, zIndex: 2100 }}>
                <Button
                    size="small"
                    variant="contained"
                    onClick={toggleFooter}
                    startIcon={footerOpen ? <ChevronDown sx={{ fontSize: 16 }} /> : <ChevronUp sx={{ fontSize: 16 }} />}
                    sx={{
                        position: 'absolute',
                        top: -50,
                        left: 16,
                        borderRadius: 20,
                        textTransform: 'none',
                        bgcolor: 'background.paper',
                        color: 'text.primary',
                        border: '1px solid',
                        borderColor: 'divider',
                        '&:hover': { bgcolor: '#ffffff' },
                        boxShadow: 2
                    }}
                >
                    Approvals
                </Button>
            </Box>

            <ResizablePanel
                defaultSize={footerOpen ? 200 : 0.0001}
                minSize={0}
                collapsible
                sx={{
                    borderTop: footerOpen ? '1px solid #e5e7eb' : 'none',
                    transition: 'flex 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                    zIndex: 2001,
                    boxShadow: footerOpen ? '0 -15px 40px rgba(0,0,0,0.15)' : 'none',
                }}
            >
                <Box sx={{
                    height: '100%',
                    overflowY: 'auto',
                    p: 1,
                    bgcolor: '#ffffff',
                }}>
                    {isLoading ? <DocumentFooterSkeleton /> : (
                        <Stack spacing={0} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <Box sx={{ flex: 1, overflowY: 'auto' }}>
                                <DynamicTabsComponent
                                    titles={Object.values(FooterCategories).map((item) => ({
                                        status: 'wait',
                                        title: item.length === 1 ? item[0].title : item.map((i) => i.title).join(' / ')
                                    }))}
                                    DynamicJson={FooterCategories}
                                    isBodySection={false}
                                    id="footer"
                                />
                            </Box>
                        </Stack>
                    )}
                </Box>
            </ResizablePanel>

            <Box
                sx={{
                    position: 'fixed',
                    bottom: 16,
                    left: 16,
                    zIndex: 1100,
                    display: footerOpen ? 'none' : 'flex'
                }}
            >
                <Button
                    size="small"
                    variant="contained"
                    onClick={toggleFooter}
                    startIcon={<ChevronUp sx={{ fontSize: 16 }} />}
                    sx={{
                        borderRadius: 20,
                        textTransform: 'none',
                        bgcolor: 'background.paper',
                        color: 'text.primary',
                        border: '1px solid',
                        borderColor: 'divider',
                        '&:hover': { bgcolor: 'grey.100' },
                        boxShadow: 3
                    }}
                >
                    Open Footer
                </Button>
            </Box>
        </>
    )
}

export default Footer